import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'drdp-features',
    templateUrl: './features.component.html',
    styleUrls: ['./features.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FeaturesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
